import { UUID } from "@bitory-gmbh/nidavellir";
import { backendApi } from "@/services/backend/api";
import { Catalog } from "@/services/backend/textblocks/types/catalog";
import { Filter } from "@/shared/lib/filter/filter";
import { providesList } from "@/services/backend/_lib/tag-helpers";

const catalogApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["TextblockCatalog"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      textblocksCatalogPut: build.mutation<Catalog, PutRequest>({
        query: (request) => ({
          url: `/textblocks/catalog`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["TextblockCatalog"],
      }),
      textblocksCatalogShow: build.query<Catalog, ShowRequest>({
        query: (request) => ({
          url: `/textblocks/catalog/${request.id}`,
          method: "GET",
        }),
        providesTags: (_result, _error, request) => [
          { type: "TextblockCatalog", id: request.id },
        ],
      }),
      textblocksCatalogList: build.query<List, ListRequest>({
        query: (request) => ({
          url: `/textblocks/catalog`,
          method: "GET",
          params: { request: btoa(JSON.stringify(request)) },
        }),
        providesTags: (result) =>
          providesList(result?.items, "TextblockCatalog"),
      }),
      textblocksCatalogDelete: build.mutation<Catalog, DeleteRequest>({
        query: (request) => ({
          url: `/textblocks/catalog`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["TextblockCatalog"],
      }),
    }),
  });

export const {
  useTextblocksCatalogPutMutation,
  useTextblocksCatalogShowQuery,
  useTextblocksCatalogListQuery,
  useTextblocksCatalogDeleteMutation,
} = catalogApi;

export type PutRequest = Catalog;

export type ShowRequest = {
  id: UUID;
};

export type ListRequest = {
  company?: Filter<UUID>;
  customer?: Filter<UUID>;
  name?: Filter<UUID>;
  active?: Filter<boolean>;
};

export type List = {
  items: Catalog[];
  count: number;
  offset: number;
  totalCount: number;
};

export type DeleteRequest = {
  id: UUID;
};
